// @generated by protoc-gen-grpc-gateway-es v0.5.0 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/cloud/discovery/v1/service_api.proto (package ai.h2o.cloud.discovery.v1, syntax proto3)
/* eslint-disable */

import type { Service } from "./service_pb";
import { RPC } from "../../../../../runtime";

/**
 * @generated from message ai.h2o.cloud.discovery.v1.GetServiceRequest
 */
export type GetServiceRequest = {
/**
 * Name of the requested Service. For example: "services/my-service-name".
 *
 * @generated from field: string name = 1;
 */
name?: string;
}
;
/**
 * @generated from message ai.h2o.cloud.discovery.v1.GetServiceResponse
 */
export type GetServiceResponse = {
/**
 * @generated from field: ai.h2o.cloud.discovery.v1.Service service = 1;
 */
service?: Service;
}
;
/**
 * @generated from message ai.h2o.cloud.discovery.v1.ListServicesRequest
 */
export type ListServicesRequest = {
/**
 * Maximum number of items server should return in the response. When set to 0
 * server will decide how many items to return.
 *
 * @generated from field: int32 page_size = 1;
 */
pageSize?: number;
/**
 * Use value returned in next_page_token to retrieve next page of results.
 *
 * @generated from field: string page_token = 2;
 */
pageToken?: string;
}
;
/**
 * @generated from message ai.h2o.cloud.discovery.v1.ListServicesResponse
 */
export type ListServicesResponse = {
/**
 * @generated from field: repeated ai.h2o.cloud.discovery.v1.Service services = 1;
 */
services?: Service[];
/**
 * When not empty server has more results then it returned. Use this value as
 * the page_token in the ListServicesRequest to obtain next page of results.
 *
 * @generated from field: string next_page_token = 2;
 */
nextPageToken?: string;
}
;
/**
 * @generated from rpc ai.h2o.cloud.discovery.v1.ServiceService.GetService
 */
export const ServiceService_GetService = new RPC<GetServiceRequest,GetServiceResponse>("GET", "/v1/{name=services/*}");
/**
 * @generated from rpc ai.h2o.cloud.discovery.v1.ServiceService.ListServices
 */
export const ServiceService_ListServices = new RPC<ListServicesRequest,ListServicesResponse>("GET", "/v1/services");
